import { Get } from "../../../../Request";
export const getPayResult = async paykey => {
  return await Get({
    url: "/result/pay",
    data: {
      paykey,
    },
  }).then(data => {
    return data;
  });
};
